<template>
    <div>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
            v-for="(star, index) in stars" :key="index"
            class="inline-block"
            :style="{ fill: `url(#gradient${star.raw})` }">
            <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
            <defs>
                <!--
                    id has to be unique to each star fullness(dynamic offset) - it indicates fullness above
                -->
                <linearGradient :id="`gradient${star.raw}`">
                    <stop
                        id="stop1"
                        :offset="star.raw"
                        stop-opacity="1"
                        :stop-color="getFullFillColor(star)"
                    ></stop>
                    <stop
                        id="stop2"
                        :offset="star.raw"
                        stop-opacity="0"
                        :stop-color="getFullFillColor(star)"
                    ></stop>
                    <stop
                        id="stop3"
                        :offset="star.raw"
                        stop-opacity="1"
                        :stop-color="style.emptyStarColor"
                    ></stop>
                    <stop
                        id="stop4"
                        offset="1"
                        stop-opacity="1"
                        :stop-color="style.emptyStarColor"
                    ></stop>
                </linearGradient>
            </defs>
        </svg>
    </div>
</template>

<script>
/** Credits: https://codesandbox.io/s/9846q4oz4r */
export default {

    props: {
        rating: {
            default: null
        }
    },

    data() {
        return {
            emptyStar: 0,
            fullStar: 1,
            totalStars: 5,
            style: {
                fullStarColor: 'var(--accent)',
                emptyStarColor: 'var(--color-gray-400)'
            },
            stars: []
        }
    },

    methods: {
        initStars() {
            for (let i = 0; i < this.totalStars; i++) {
                this.stars.push({
                    raw: this.emptyStar
                });
            }
        },
        setStars() {
            let fullStarsCounter = Math.floor(this.rating);
            for (let i = 0; i < this.stars.length; i++) {
                if (fullStarsCounter !== 0) {
                    this.stars[i].raw = this.fullStar;
                    fullStarsCounter--;
                } else {
                    let surplus = Math.round((this.rating % 1) * 10) / 10; // Support just one decimal
                    let roundedOneDecimalPoint = Math.round(surplus * 10) / 10;
                    this.stars[i].raw = roundedOneDecimalPoint;
                    return;
                }
            }
        },
        getFullFillColor(starData) {
            return starData.raw !== this.emptyStar
                ? this.style.fullStarColor
                : this.style.emptyStarColor;
        },
    },

    mounted() {
        this.initStars();
        this.setStars();
    }

}
</script>
